module.exports = __webpack_public_path__ + "static/media/services.2bd7ad7f.jpeg";